// src/components/PricingSection.tsx
import React from 'react';
import PricingCard from './../../components/PricingCard/PricingCard';
import './PricingSection.css';

import image1 from '../../assets/Images/pricing/1.png';
import image2 from '../../assets/Images/pricing/2.png';
import image3 from '../../assets/Images/pricing/3.png';

const PricingSection: React.FC = () => {
  const pricingPlans = [
    {
      image: image1,
      price: '25',
      duration: '6 Month',
      benefits: ['Benefit 1', 'Benefit 2', 'Benefit 3', 'Benefit 4'],
    },
    {
      image: image2,
      price: '74',
      duration: 'Per Year',
      benefits: ['Benefit 1', 'Benefit 2', 'Benefit 3', 'Benefit 4'],
      mostPopular: true,
    },
    {
      image: image3,
      price: '150',
      duration: 'Lifetime',
      benefits: ['Benefit 1',  'Benefit 2', 'Benefit 3', 'Benefit 4'],
    },
  ];
 
  return (
    <div className="pricing-section">
      <h2 className="pricing-title">Membership</h2>
      <p className="pricing-subtitle">Unlock all functions, get a membership</p>
      <div className="pricing-cards">
        {pricingPlans.map((plan, index) => (
          <PricingCard
            key={index}
            image={plan.image}
            price={plan.price}
            duration={plan.duration}
            benefits={[
              { benefit: 'Feature 1', description: 'Detailed explanation of Feature 1.' },
              { benefit: 'Feature 2', description: 'Detailed explanation of Feature 2.' },
            ]}
            mostPopular={plan.mostPopular}
          />
        ))}
      </div>
    </div>
  );
};

export default PricingSection;
